import { setLocalStorageTodoFilterSettings } from "api/dropsLocalStorage";
import {
  ListContainer,
  TodoMessageWrapper,
} from "features/TodoOploggSidebar/Todo/TodoStyles";
import {
  defaultTodoFilterState,
  TodoFilterState,
} from "features/TodoOploggSidebar/Todo/todoFilter/useTodoFilterState";
import TodoList from "features/TodoOploggSidebar/Todo/todoList/TodoList";
import useTodo from "features/TodoOploggSidebar/Todo/useTodo";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { useEffect } from "react";
import { Box } from "shared/components/Spor";
import SkeletonLoader from "shared/components/feedback/SkeletonLoader/SkeletonLoader";
import { Text } from "shared/components/typography/TitleStyles";
import { getTodoRole } from "shared/types/roles";
import { useDropsRole } from "stores/useDropsRole";

export type TodoStatus = "active" | "inActive";

const TodoComponent = ({
  todoFilterState,
  setTodoFilterState,
}: {
  todoFilterState: TodoFilterState;
  setTodoFilterState: (state: TodoFilterState) => void;
}) => {
  useEffect(() => {
    setLocalStorageTodoFilterSettings(todoFilterState);
  }, [todoFilterState]);

  const { status, data } = useTodo();

  const { role: currentRole } = useDropsRole();

  useEffect(() => {
    if (!todoFilterState.roles.includes(currentRole)) {
      setTodoFilterState({
        ...defaultTodoFilterState,
        roles: getTodoRole(currentRole),
      });
    }
  }, [currentRole]);

  switch (status) {
    case "pending":
      return (
        <TodoMessageWrapper>
          <SkeletonLoader skeletonType="todo" />
        </TodoMessageWrapper>
      );
    case "error":
      log(LogLevel.error, "TodoComponent", "Feil ved henting av todo-data");
      return (
        <TodoMessageWrapper>
          <Box m="8px">
            <Text>Feil ved henting av todo-data</Text>
          </Box>
        </TodoMessageWrapper>
      );
    case "success":
      return (
        <TodoMessageWrapper>
          <ListContainer>
            {data && (
              <TodoList todoList={data} todoFilterState={todoFilterState} />
            )}
          </ListContainer>
        </TodoMessageWrapper>
      );
  }
};

export default TodoComponent;
